var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDashboardInvitationPendingGrey(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45.435,
    height: 50,
    viewBox: "0 0 45.435 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 165",
    d: "M29.94 321.214a2.015 2.015 0 0 0-2.609 0L6.558 338.869a2.005 2.005 0 0 0 1.374.544h41.406a2.005 2.005 0 0 0 1.374-.544z",
    transform: "translate(-5.918 -289.413)",
    style: {
      fill: "#e2e9f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 166",
    d: "m269.148 222.391 18.511 15.732a2.007 2.007 0 0 0 .64-1.47v-27.567z",
    transform: "translate(-242.864 -188.668)",
    style: {
      fill: "#d3dae4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 167",
    d: "m.64 238.123 18.511-15.732L0 209.086v27.567a2.007 2.007 0 0 0 .64 1.47z",
    transform: "translate(0 -188.668)",
    style: {
      fill: "#d3dae4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 168",
    d: "m.731 353.53 18.51-15.73-1.173-.815L.1 352.254a2.009 2.009 0 0 0 .631 1.276z",
    transform: "translate(-.09 -304.075)",
    style: {
      fill: "#bfcbd7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 169",
    d: "m287.659 353.53-18.511-15.73 1.173-.815 17.969 15.271a2.009 2.009 0 0 1-.631 1.276z",
    transform: "translate(-242.864 -304.075)",
    style: {
      fill: "#bfcbd7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 170",
    d: "M5.721 159.3v8.836L0 164.16z",
    transform: "translate(0 -143.742)",
    style: {
      fill: "#bfcbd7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 171",
    d: "m0 199.868 5.721 3.974v-1.813l-4.547-3.159z",
    transform: "translate(0 -179.449)",
    style: {
      fill: "#93a6b9",
      opacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 172",
    d: "M406.677 159.3v8.836l5.721-3.974z",
    transform: "translate(-366.963 -143.742)",
    style: {
      fill: "#bfcbd7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 173",
    d: "M406.676 202.029v1.813l5.721-3.974-1.174-1z",
    transform: "translate(-366.962 -179.449)",
    style: {
      fill: "#93a6b9",
      opacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 174",
    d: "m72.011 33.723 2.262-1.923a2.015 2.015 0 0 1 2.609 0l2.262 1.922 13.43-9.33V.5a.5.5 0 0 0-.5-.5h-32.99a.5.5 0 0 0-.5.5v23.89z",
    transform: "translate(-52.819)",
    style: {
      fill: "#f8f9fa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 175",
    d: "m74.261 33.723 2.262-1.923a2.015 2.015 0 0 1 2.609 0l2.262 1.922 13.43-9.33V.5a.5.5 0 0 0-.5-.5h-32.99a.5.5 0 0 0-.5.5v23.89l13.43 9.33z",
    transform: "translate(-55.069)",
    style: {
      fill: "#f8915b",
      opacity: 0.08
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 176",
    d: "m79.144 240.546-2.262-1.922a2.015 2.015 0 0 0-2.609 0l-2.262 1.922-13.43-9.33v1.813l13.43 9.33 2.262-1.922a2.015 2.015 0 0 1 2.609 0l2.262 1.922 13.43-9.33v-1.813z",
    transform: "translate(-52.86 -208.636)",
    style: {
      fill: "#b59e95",
      opacity: 0.12
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 177",
    d: "M164.185 78.984a7.385 7.385 0 1 0 7.385 7.385 7.385 7.385 0 0 0-7.385-7.385zm2.489 9.874a.671.671 0 0 1-.949 0l-2.014-2.014a.671.671 0 0 1-.2-.475v-4.028a.671.671 0 1 1 1.343 0v3.75l1.817 1.817a.671.671 0 0 1 0 .949z",
    transform: "translate(-141.488 -71.271)",
    style: {
      fill: "#ff6b6b"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardInvitationPendingGrey);
export default __webpack_public_path__ + "static/media/dashboard-invitation-pending-grey.4c69b1d02ad782fbda3ba9f1c4c6bff7.svg";
export { ForwardRef as ReactComponent };